import { Pipe, PipeTransform } from '@angular/core';

import { isEmpty, isNil, trim } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

import { StringUtility } from './../string-utility';

@Pipe({
  name: 'getAddressGps',
})
export class GetAddressGpsPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(metaData: any, ...args: any[]) {
    const gps = '';
    if (isNil(metaData?.address) || isEmpty(trim(metaData?.address?.replace(/(\r\n|\n|\r)/gm, '')))) {
      return gps.concat(
        this.translateService.instant('module.modals.sensorDeviceOnboarding.locationLongitude'),
        ' ',
        metaData?.latitude.toFixed(6),
        '\r\n',
        this.translateService.instant('module.modals.sensorDeviceOnboarding.locationLatitude'),
        ' ',
        metaData?.longitude.toFixed(6)
      );
    } else {
      return StringUtility.removeTrailingSpaces(metaData?.address);
    }
  }
}
